import localForage from 'localforage';

class HeadersDB {
    constructor(storeName) {
        this.storage = localForage.createInstance();
        this.storage.config({
            name: 'Lumenite-GQL',
            storeName,
        });
        this.key = storeName;
    }

    getHeaders() {
        return this.storage.getItem(this.key);
    }

    updateHeaders(newHeaders) {
        return this.storage.setItem(this.key, newHeaders || {});
    }
};

const headersDB = new HeadersDB('requestHeaders');

export default headersDB;